import 'reflect-metadata';
import 'zone.js';
import '@angular/compiler';
import { ɵresolveComponentResources as resolveComponentResources } from '@angular/core';
import './assets/scss/main.scss';
import 'font-awesome/css/font-awesome.css';

import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

// Leaflet's UMD build assigns window.L itself; don't replace it with a copy —
// leaflet-draw and leaflet-google extend that live object at module-eval time
// (C2026-184: the Rollup namespace copy misses plugin extensions in prod builds).
import 'leaflet';
import 'leaflet-draw';
import * as EsriLeaflet from 'esri-leaflet';
import * as EsriLeafletGeocoder from 'esri-leaflet-geocoder';
(window as any).L.esri = { ...EsriLeaflet, Geocoding: { ...EsriLeafletGeocoder } };
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'ngx-bootstrap/datepicker/bs-datepicker.css';

import { enableProdMode, APP_INITIALIZER } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { switchMap, NEVER, of } from 'rxjs';

import { DashboardComponent } from './dashboard/dashboard.component';
import { dashboardRoutes } from './dashboard/dashboard.routes';
import { authInterceptor } from './utils/auth.interceptor';
import { KeycloakService } from './services/keycloak.service';
import { SSOService } from './services/sso.service';
import { I18nService } from './services/i18n.service';
import { ENV } from './utils/env';

if (ENV === 'prod') {
  enableProdMode();
}

// Resolve templateUrl for all standalone components so dynamic createComponent() works
resolveComponentResources((url) => fetch(url).then((r) => r.text()));

// SSO then Keycloak init, then bootstrap
SSOService.init()
  .pipe(
    switchMap((ssoResult: any) => {
      if (!ssoResult) {
        return KeycloakService.init();
      } else {
        return of(true);
      }
    }),
  )
  .subscribe({
    next: () => {
      bootstrapApplication(DashboardComponent, {
        providers: [
          provideAnimations(),
          provideRouter(dashboardRoutes),
          provideHttpClient(withInterceptors([authInterceptor])),
          {
            provide: APP_INITIALIZER,
            useFactory: (i18nService: I18nService) => {
              return () => i18nService.loadI18nInfo();
            },
            deps: [I18nService],
            multi: true,
          },
        ],
      }).catch((err) => console.error('Bootstrap error:', err));
    },
    error: (x: any) => {
      try {
        const error = typeof x?.json === 'function' ? x.json() : typeof x === 'object' ? x : null;
        if (error?.errorCode === 'invalid') {
          const data = error.data;
          if (data && data.ssoLogin) {
            const providerCode: string = data.ssoProvider;
            const providerString = SSOService.toProviderString(providerCode);
            alert("L'interconnexion " + providerString + " est invalide. Code d'erreur : " + data.ssoLogin);
          }
          return;
        }
      } catch (ex) {
        // ignore
      }
      window.location.reload();
    },
  });
